import _ from 'lodash';

import {panelSortingKeyFromPanel} from '../../../util/panelbank';
import * as PanelsUtil from '../../../util/panels';
import {setInShallowClone} from '../../../util/utility';
import * as Normalize from '../normalize';
import {StateType} from '../normalizerSupport';
import * as PanelTypes from '../panel/types';
import {ActionType, ViewReducerState} from '../reducerSupport';
import * as Actions from './actions';
import {PanelBankSectionConfigNormalized, Ref} from './types';

export const toggleIsOpen = (
  state: ViewReducerState,
  ref: Ref
): [ViewReducerState, ActionType] => {
  const curSectionConfig = state.parts[ref.type][ref.id];
  const newState = setInShallowClone(
    state,
    ['parts', ref.type, ref.id, 'isOpen'],
    !curSectionConfig.isOpen
  );
  const inverseAction = Actions.toggleIsOpen(ref);
  return [newState, inverseAction];
};

const movePanelAlphabeticallyKey = (key: string | undefined) => {
  if (key === undefined) {
    return '0';
  } else {
    return '1' + key;
  }
};

export function insertPanelAlphabetically(
  parts: StateType,
  normalizedSectionConfig: PanelBankSectionConfigNormalized,
  panel: PanelsUtil.LayedOutPanel | PanelsUtil.LayedOutPanelWithRef,
  panelRef: PanelTypes.Ref
) {
  const panelKey = panelSortingKeyFromPanel(panel);
  const panelKeys = normalizedSectionConfig.panelRefs.map(oldPanelRef => {
    const sectionPanel = Normalize.denormalize(parts, oldPanelRef);
    return panelSortingKeyFromPanel(sectionPanel);
  });
  const index = _.sortedIndexBy(
    panelKeys,
    panelKey,
    movePanelAlphabeticallyKey
  );
  normalizedSectionConfig.panelRefs.splice(index, 0, panelRef);
}

export function movePanelAlphabeticallyInSection(
  state: ViewReducerState,
  normalizedSectionConfig: PanelBankSectionConfigNormalized,
  panelRef: PanelTypes.Ref,
  panel: PanelsUtil.LayedOutPanel
) {
  const panelKeys = normalizedSectionConfig.panelRefs
    .filter(oldPanelRef => oldPanelRef.id !== panelRef.id)
    .map(oldPanelRef => {
      const sectionPanel = Normalize.denormalize(state.parts, oldPanelRef);
      return panelSortingKeyFromPanel(sectionPanel);
    });
  const newPanelIndex = _.sortedIndexBy(
    panelKeys,
    panelSortingKeyFromPanel(panel),
    movePanelAlphabeticallyKey
  );
  const origPanelIndex = normalizedSectionConfig.panelRefs.findIndex(
    sectionPanelRef => sectionPanelRef.id === panelRef.id
  );
  normalizedSectionConfig.panelRefs.splice(origPanelIndex, 1);
  normalizedSectionConfig.panelRefs.splice(newPanelIndex, 0, panelRef);
}
